import { useState } from 'react';
import api from '../../api/api';
import { Link, useNavigate } from 'react-router-dom';
import { routes } from '../../config/utility';
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Register = () => {
    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    // const handlePhoneChange = (phone) => {
    //     setForm({ ...form, phone });
    // };

    const handleRegister = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/signup', form);
            navigate(routes.verify, { state: { email: form.email } });
        } catch (error) {
            // Registration error
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-gradientStart to-gradientEnd px-4">
            <div className="bg-white px-10 py-4 rounded-3xl shadow-xl w-full max-w-xl transform transition duration-500 ease-in-out hover:shadow-2xl hover:scale-101 relative">

                {/* Logo */}
                <div className="text-center">
                    <img src="/assets/logo.png" alt="Logo" className="w-28 mx-auto" />
                    <img src="/assets/written-pawdash.svg" alt="Logo" className="w-44 mt-2 mb-6 mx-auto" />

                    <h2 className="text-3xl font-extrabold text-primary mt-4">Join PawDash! 🐶</h2>
                    <p className="text-gray-600 text-sm mt-2">Create an account and make life easier for you and your furry friend!</p>
                </div>

                {/* Registration Form */}
                <form onSubmit={handleRegister} className="space-y-6 mt-6">
                    <div>
                        <label className="block text-gray-600 font-medium mb-1">Full Name</label>
                        <input
                            type="text"
                            name="name"
                            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primary transition-transform focus:scale-105 shadow-sm"
                            placeholder="Enter your full name"
                            required
                            value={form.name}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="block text-gray-600 font-medium mb-1">Phone</label>
                        <ReactPhoneInput
                            country={"ae"}
                            value={form.phone}
                            onChange={(value) =>
                                setForm({ ...form, phone: value })
                            }
                            inputStyle={{
                                width: "90%",
                                padding: "14px 20px",
                                border: "1px solid #d1d5db",
                                borderRadius: "8px",
                                fontSize: "16px",
                                color: "#4b5563",
                                marginLeft: "45px",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                height: "50px",
                            }}
                            buttonStyle={{
                                borderRadius: "8px 0 0 8px",
                                paddingRight: "10px",
                                height: "50px",
                            }}
                            containerClass="mb-4"
                            inputClass="focus:ring-purple-500 focus:border-purple-500"
                            dropdownClass="phone-dropdown"
                            searchPlaceholder="Search for country"
                            enableSearch={true}
                            searchStyle={{
                                padding: "10px 12px",
                                fontSize: "14px",
                                border: "1px solid #d1d5db",
                                borderRadius: "8px",
                            }}
                        />
                    </div>

                    <div>
                        <label className="block text-gray-600 font-medium mb-1">Email</label>
                        <input
                            type="email"
                            name="email"
                            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primary transition-transform focus:scale-105 shadow-sm"
                            placeholder="Enter your email"
                            required
                            value={form.email}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="block text-gray-600 font-medium mb-1">Password</label>
                        <input
                            type="password"
                            name="password"
                            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primary transition-transform focus:scale-105 shadow-sm"
                            placeholder="Enter your password"
                            required
                            value={form.password}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label className="block text-gray-600 font-medium mb-1">Confirm Password</label>
                        <input
                            type="password"
                            name="password_confirmation"
                            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primary transition-transform focus:scale-105 shadow-sm"
                            placeholder="Confirm your password"
                            required
                            value={form.password_confirmation}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Register Button */}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 text-white bg-primary rounded-lg shadow-lg transition-transform duration-300 ease-in-out hover:scale-105 active:scale-95 flex items-center justify-center gap-2"
                    >
                        {loading ? "Registering..." : "Sign Up"}
                    </button>
                </form>

                {/* Footer Links */}
                <div className="mt-6 text-center">
                    <Link to={routes.login} className="text-primary text-sm hover:underline">
                        Already have an account? Sign in
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Register;
